import { useEffect, useMemo, useRef, useState } from 'react'
import { SAlert, SDrawerOrModal, SGeneralForms, SSteps } from 'shj-components'
import Step2 from './step2'
import { Button, Col, Form, Input, InputNumber, message, Row, Select, Spin } from 'antd'
import styles from '../../index.module.less'
import {
  addQuoteBudget,
  quoteBudgetInitQuoteBudgetItem,
  quoteBudgetSelectBudgetInitArg,
  quoteBudgetSelectCreatorEntryPrice,
  orderStandInStartWorkFlow,
} from '@/services/order.ts'
import { useSetState, useUpdateEffect } from 'ahooks'
import { debounce, get, isArray } from 'lodash-es'

import { ArrowRightOutlined } from '@ant-design/icons'
import { getEnums } from "@/services/homeService.ts";
import { getBusinessDictList } from "@/services/product.ts";
interface IProps {
  title: string
  quoteGoodsId: string
  open: boolean
  setOpen: (open: boolean) => void
  fn: () => void
  reloadDetail: () => void
  detailsInfo: any
}
export default function AddQuotationDrawer(prpos: IProps) {
  const formRef = useRef(null)
  const [form] = Form.useForm()
  const tableRef = useRef(null)
  const { open, title, setOpen, quoteGoodsId,detailsInfo } = prpos
  const [current, setCurrent] = useState(0)
  const [state, setState] = useSetState<any>({
    argList: [], //规格渲染表单数据
    reArgList: [], //规格原数据
    priceArgList: [], //价格规格渲染表单数据
    rePriceArgList: [], //价格规格参数原数据
    budgetType: '',
    argValues: {}, // formValues
    resPriceList: [], //保存所需价格规格参数
    resArgList: [], //保存所需规格参数
    loading: false,
    btnLoading: false,
    steps: [{ title: '选择规格' }, { title: '户型管理' }],
    spaceArgList: [], //空间规格参数
    changeReasonEnum: [], //变更原因
    isShowChangeReason: false, // 展示变更原因
  })
  const [showStartWorkTipOpen, setShowStartWorkTipOpen] = useState(false)
  const [spaceLoading, setSpaceLoading] = useState(false)
  const spaceQuoteBudgetItemList = Form.useWatch('spaceQuoteBudgetItemList', form)
  const [lastFormValue, setLastFormValue] = useState({});

  useEffect(() => {
    console.log('open---->', open)
    if (quoteGoodsId) getArgs()
    setCurrent(0)
    if(open) {
      getOrgs()
    }
    return () => {
      setState({isShowChangeReason: false})
    }
  }, [open])

  const getOrgs = async () => {
    const orgIds = await getBusinessDictList({ data: { priKey: 'startWorkAfterChooseSpecialOrgIds', enabled: true } })
    const raw = get(orgIds, '[0].children.[0].object.dataValue', '')
    const idSet = new Set(
      raw
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
    )
    const companyId = String(detailsInfo?.orgId ?? '').trim()
    if(idSet.has(companyId)){
        getChangeEnum()
    } else {
      setState({changeReasonEnum: [], isShowChangeReason: false})
    }
  }

  const getChangeEnum = async () => {
    const changeReasonEnum = await getEnums('plus-trade', 'com.shj.saas.plus.trade.enums.ChangeReasonEnum')
    setState({changeReasonEnum, isShowChangeReason: true})
  }

  const steps = useMemo(() => {
    return state.budgetType === 'bidMainContract' ? state.steps : [state.steps[0]]
  }, [state.steps, state.budgetType])

  useEffect(() => {
    if (state.budgetType) {
      form.setFieldValue('spaceQuoteBudgetItemList', [])
      setState({ spaceArgList: [] })
      getArgs(state.budgetType)
      getPriceArgs()
    }
  }, [state.budgetType])

  const getArgs = (budgetType?: string) => {
    setState({ loading: true })
    quoteBudgetSelectBudgetInitArg({ params: { quoteGoodsId, budgetType } })
      .then(res => {
        let data: any = res
        console.log(data, 'data')
        // 报价类型无选项时 判断是否在开工中
        if (
          isArray(data) &&
          data.find(item => item.argCode === 'budgetType')?.values?.length === 0
        ) {
          checkIsStartWork()
        }
        setState({ reArgList: res, argList: [...data] })
        if (!budgetType) {
          return
        }
        const values = form.getFieldsValue()
        const arg = data.map(item => {
          return {
            argCode: item.argCode,
            argName: item.argName,
            argType: item.argType,
            [item.argType === 'CHOOSE' ? 'argValCode' : 'argVal']:
              item.argType === 'CHOOSE' ? values[item.argCode] || '' : values[item.argCode] || item.inputValue || '',
          }
        })
        getSpaceArgs(arg || [], {})
      })
      .then(() => setState({ loading: false }))
      .catch(() => setState({ loading: false }))
  }
  const checkIsStartWork = ()=>{
      orderStandInStartWorkFlow(detailsInfo?.orderId).then((res: any) => {
        setShowStartWorkTipOpen(res)
      })
  }
  const getPriceArgs = () => {
    setState({ loading: true })
    quoteBudgetSelectCreatorEntryPrice({ params: { quoteGoodsId, budgetType: state.budgetType } })
      .then(res => {
        let data: any = res
        setState({ rePriceArgList: res, priceArgList: [...data] })
      })
      .finally(() => setState({ loading: false }))
  }

  const getSpaceArgs = async (data, changedValues) => {
    setSpaceLoading(true)
    quoteBudgetInitQuoteBudgetItem({
      data: {
        quoteGoodsId,
        budgetType: state.budgetType,
        format: JSON.stringify(data),
      },
    }).then(res => {
      setState({ spaceArgList: res })
      setSpaceLoading(false)
      if (Array.isArray(res)) {
        form.setFieldValue('spaceQuoteBudgetItemList', res)
      }
      setLastFormValue(form.getFieldsValue());
    }).catch(() => {
      if (Object.keys(changedValues || {})?.[0]) {
        form.setFieldValue(Object.keys(changedValues || {})?.[0], lastFormValue?.[Object.keys(changedValues || {})?.[0]]);
      }
      setSpaceLoading(false)
    })
  }

  const onValuesChange = (changedValues, allValues: any) => {
    const argCodeList = state.argList?.map((item: any) => item.argCode)
    if (changedValues && !argCodeList?.includes(Object.keys(changedValues)?.[0])) {
      setLastFormValue(allValues)
      return
    }
    if (Object.keys(changedValues)?.[0] === 'budgetType') {
      setLastFormValue(allValues)
      return
    }
    if (
      ['bidGrassContract', 'bidMainContract', 'bidAdditionContract'].includes(state.budgetType) ||
      ['bidGrassContract', 'bidMainContract', 'bidAdditionContract'].includes(
        changedValues.budgetType
      )
    ) {
      checkAllArgHasValue(allValues, changedValues)
    }
  }

  const changeFormValue = (value: any) => {
    form.setFieldValue('spaceQuoteBudgetItemList', value)
  }
  const checkAllArgHasValue = debounce((formvalue, changedValues) => {
    console.log(state.argList, 'state.argList')
    const flag = state?.argList
      ?.filter((arg: any) => arg.argType === 'CHOOSE')
      ?.every((item: any) => formvalue[item.argCode]) // 检查是否都有值
    if (flag) {
      const keys = Object.keys(formvalue)
      const arg = state.argList.map(item => {
        if (keys.includes(item.argCode)) {
          return {
            argCode: item.argCode,
            argName: item.argName,
            argType: item.argType,
            [item.argType === 'CHOOSE' ? 'argValCode' : 'argVal']:
              state.argValues[item.argCode]?.code ||
              state.argValues[item.argCode]?.id ||
              formvalue[item.argCode],
            [item.argType === 'CHOOSE' ? 'argValName' : 'argVal']:
              state.argValues[item.argCode]?.name || formvalue[item.argCode],
          }
        }
      })
      getSpaceArgs(arg, changedValues)
    }
  }, 500)
  const next = () => {
    if (current === 1) return
    checkForm().then(() => {
      setCurrent(current + 1)
    })
  }

  const prev = () => {
    if (current === 0) return
    setCurrent(current - 1)
  }
  const onConfirm = () => {
    console.log(123)
  }

  const save = async () => {
    try {
      let houseHoldData = tableRef?.current?.data || spaceQuoteBudgetItemList
      const notShowName = houseHoldData?.some(item => !item.showName)
      if (notShowName) return message.error('显示名称不能为空')
      setState({ btnLoading: true })
      const data: any = await checkForm()
      const remark = form.getFieldValue('remark')
      const changeReason = form.getFieldValue('changeReason')
      const values = {
        quoteGoodsId,
        type: state.budgetType,
        remark,
        changeReason,
        spaceBudgetItemList: houseHoldData?.map((item: any, index: number) => {
          return { ...item, sort: index + 1 }
        }),
        quoteBudgetPriceList: data.priceList,
        format: JSON.stringify(data.argList),
      }
      addQuoteBudget({ data: values })
        .then(res => {
          message.success(res.message || '操作成功')
          onCancel()
          prpos.fn?.()
          prpos.reloadDetail?.()
        })
        .finally(() => setState({ btnLoading: false }))
    } catch (e) {
      setState({ btnLoading: false })
    }
  }

  const checkForm = () => {
    return new Promise((resolve, reject) => {
      form
        .validateFields()
        .then(res => {
          const keys = Object.keys(res)
          const data = state.rePriceArgList.map(item => {
            if (keys.includes(item.configId)) {
              return { ...item, price: res[item.configId] }
            }
          })
          const arg = state.argList.map(item => {
            if (keys.includes(item.argCode)) {
              return {
                argCode: item.argCode,
                argName: item.argName,
                argType: item.argType,
                [item.argType === 'CHOOSE' ? 'argValCode' : 'argVal']:
                  state.argValues[item.argCode]?.code ||
                  state.argValues[item.argCode]?.id ||
                  res[item.argCode],
                [item.argType === 'CHOOSE' ? 'argValName' : 'argVal']:
                  state.argValues[item.argCode]?.name || res[item.argCode],
              }
            }
          })
          setState({ resPriceList: data, resArgList: arg })
          resolve({ priceList: data, argList: arg })
        })
        .catch(reject)
    })
  }

  const onCancel = () => {
    form.resetFields()
    setOpen(false)
    setState({
      priceArgList: [],
      rePriceArgList: [],
      spaceArgList: [],
      // argList:[],
      budgetType: '',
      btnLoading: false,
      loading: false,
    })
    setShowStartWorkTipOpen(false)
  }

  const okRender = () => {
    return (
      <>
        <Button className={styles.buttonMr10} onClick={onCancel}>
          取消
        </Button>
        {current === 1 && (
          <Button onClick={prev} className={styles.buttonMr10}>
            上一步
          </Button>
        )}
        {current < steps.length - 1 ? (
          <Button type="primary" onClick={next} className={styles.buttonMr10}>
            户型管理 <ArrowRightOutlined />
          </Button>
        ) : (
          <Button
            type="primary"
            onClick={save}
            loading={state.btnLoading}
            disabled={state.btnLoading}
          >
            保存
          </Button>
        )}
      </>
    )
  }
  return (
    <SDrawerOrModal
      title={title}
      mode="drawer"
      open={open}
      width={1010}
      onCancel={onCancel}
      onOk={onConfirm}
      antdProps={{
        footer: okRender(),
      }}
      loading={state.loading}
    >
      {open && (
        <div className={styles.addPrize}>
          <div style={{ display: `${current === 0 ? 'block' : 'none'}` }}>
            <div className={styles.addQuotationDrawer}>
              {/* 表单 */}
              {showStartWorkTipOpen && (
                <div style={{ marginBottom: 10 }}>
                  <SAlert type="info">当前订单正在申请开工，暂时无法新增报价。</SAlert>
                </div>
              )}
              <Form
                name="basic"
                form={form}
                wrapperCol={{ span: 24 }}
                // style={{ maxWidth: 800 }}
                layout={'vertical'}
                initialValues={{}}
                onValuesChange={onValuesChange}
              >
                <Row>
                  <Spin spinning={spaceLoading}>
                    <Row>
                      {state.argList?.length ? (
                        <Col span={24} className={styles.formTitle}>
                          商品规格
                        </Col>
                      ) : null}
                      {/* 规格参数 */}
                      {state.argList?.map((item: any) => {
                        if (item.argType === 'CHOOSE') {
                          return (
                            <Col span={12}>
                              <Form.Item
                                label={item.argName}
                                name={item.argCode}
                                required={true}
                                rules={[{ required: true, message: `${item.argName}不能为空` }]}
                              >
                                <Select
                                  placeholder={`请输入${item.argName}`}
                                  style={{ width: '100%', maxWidth: 460 }}
                                  allowClear
                                  showSearch
                                  optionFilterProp={'name'}
                                  options={item?.values || []}
                                  onChange={(key: string, option: any) => {
                                    setState({
                                      argValues: { ...state.argValues, [item.argCode]: option },
                                    })
                                    if (item.argCode !== 'budgetType') return
                                    setState({ budgetType: key })
                                  }}
                                  fieldNames={{
                                    label: 'valueName',
                                    value: `${
                                      item.argCode !== 'budgetType' ? 'valueId' : 'valueCode'
                                    }`,
                                  }}
                                ></Select>
                              </Form.Item>
                            </Col>
                          )
                        } else {
                          return (
                            <Col span={12}>
                              <Form.Item
                                label={item.argName}
                                name={item.argCode}
                                required={true}
                                initialValue={item.inputValue}
                                rules={[{ required: true, message: `${item.argName}不能为空` }]}
                              >
                                <Input style={{ width: '100%', maxWidth: 460 }}></Input>
                              </Form.Item>
                            </Col>
                          )
                        }
                      })}
                      {/* 空间规格 */}
                      {state.spaceArgList?.filter(item => item?.spaceSpecParamValues?.length)
                        ?.length ? (
                        <Col span={24} className={styles.formTitle}>
                          空间规格
                        </Col>
                      ) : null}
                      <Form.List name="spaceQuoteBudgetItemList">
                        {fields =>
                          fields.map((field: any, index) => (
                            <Col
                              span={12}
                              style={{
                                display: form.getFieldValue('spaceQuoteBudgetItemList')?.[index]
                                  ?.spaceSpecParamValues?.length
                                  ? 'block'
                                  : 'none',
                              }}
                            >
                              <Form.Item
                                {...field}
                                name={[index, 'spaceSpecParamValueId']}
                                label={
                                  form.getFieldValue('spaceQuoteBudgetItemList')?.[index]?.showName
                                }
                                rules={[
                                  {
                                    required: form.getFieldValue('spaceQuoteBudgetItemList')?.[index]
                                      ?.spaceSpecParamValues?.length
                                      ? true
                                      : false,
                                    message: `${
                                      form.getFieldValue('spaceQuoteBudgetItemList')?.[index]
                                        ?.showName
                                    }不能为空`,
                                  },
                                ]}
                                style={{
                                  display: form.getFieldValue('spaceQuoteBudgetItemList')?.[index]
                                    ?.spaceSpecParamValues?.length
                                    ? 'block'
                                    : 'none',
                                }}
                              >
                                <Select
                                  placeholder={`请输入${
                                    form.getFieldValue('spaceQuoteBudgetItemList')?.[index]?.showName
                                  }`}
                                  style={{ width: '100%', maxWidth: 460 }}
                                  allowClear
                                  showSearch
                                  optionFilterProp={'name'}
                                  options={
                                    form.getFieldValue('spaceQuoteBudgetItemList')?.[index]
                                      ?.spaceSpecParamValues || []
                                  }
                                  fieldNames={{
                                    label: 'argValue',
                                    value: `id`,
                                  }}
                                ></Select>
                              </Form.Item>
                            </Col>
                          ))
                        }
                      </Form.List>
                    </Row>
                  </Spin>
                  <Col span={24} className={styles.formTitle}>
                    其他
                  </Col>
                  {state.budgetType === 'bidProjectAdditionContract' && state.isShowChangeReason && <Col span={12}>
                    <Form.Item label="变更原因" name="changeReason" required rules={[{required: true, message: '请选择变更原因'}]} >
                      <Select placeholder={'请选择变更原因'} options={state.changeReasonEnum} fieldNames={{label: 'description', value: 'key'}}/>
                    </Form.Item>
                  </Col>}
                  <Col span={12}>
                    <Form.Item label="备注" name="remark">
                      <Input
                        placeholder={'请输入备注'}
                        maxLength={255}
                        showCount
                        style={{ width: '100%', maxWidth: 460 }}
                      ></Input>
                    </Form.Item>
                  </Col>
                  {/* 价格参数 */}
                  {state.priceArgList?.map((item: any) => {
                    return (
                      <Col span={12}>
                        <Form.Item
                          label={item.name}
                          name={item.configId}
                          required
                          rules={[{ required: true, message: `${item.name}不能为空` }]}
                          initialValue={item.price}
                        >
                          <InputNumber
                            min={-99999999}
                            max={99999999}
                            precision={2}
                            style={{ width: '100%', maxWidth: 460 }}
                          ></InputNumber>
                        </Form.Item>
                      </Col>
                    )
                  })}
                </Row>
              </Form>
            </div>
          </div>
          <div style={{ display: `${current === 1 ? 'block' : 'none'}` }}>
            {current === 1 && (
              <Step2
                spaceQuoteBudgetItemList={spaceQuoteBudgetItemList}
                ref={tableRef}
                query={{
                  quoteGoodsId,
                  type: state.budgetType,
                  format: JSON.stringify(state.resArgList),
                }}
                changeFormValue={changeFormValue}
              />
            )}
          </div>
        </div>
      )}
    </SDrawerOrModal>
  )
}
